import request from '../utils/serverrequest'


export function wxlogin(data) {
    return request({
    url: '/wxlogin',
    method: 'post',
    data
    })
}


export function wxlogintest(data) {
    return request({
    url: '/wxtestlogin',
    method: 'post',
    data
    })
}


export function getCustomer(params) {
    return request({
    url: '/wx/wx/customer',
    method: 'get',
    params
    })
}

export function getShops(params) {
    return request({
    url: '/wx/wx/getshops',
    method: 'get',
    params
    })
}